/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { useTheme } from '../utils/index.js';
import cx from 'classnames';
/**
 * A stylized display to communicate common http errors and other non-ideal states.
 * Works well with svgs from @itwin/itwinui-illustrations-react.
 *
 * @example
 * <NonIdealState svg={<Svg404 />} heading='Not found' />
 */
export const NonIdealState = (props) => {
    const { className, svg, heading, description, actions, ...rest } = props;
    useTheme();
    return (React.createElement("div", { className: cx('iui-non-ideal-state', className), ...rest },
        React.createElement("div", { className: 'iui-non-ideal-state-illustration' }, svg),
        heading && React.createElement("div", { className: 'iui-non-ideal-state-title' }, heading),
        description && (React.createElement("div", { className: 'iui-non-ideal-state-description' }, description)),
        actions && React.createElement("div", { className: 'iui-non-ideal-state-actions' }, actions)));
};
export default NonIdealState;
